import { getVariantId, getProductPageUrl} from '//www.roomix.com/cdn/shop/t/79/assets/roomix-dt-shopify.js?v=101473530493294531301743694420'
import { openModal } from '//www.roomix.com/cdn/shop/t/79/assets/roomix-dt-modals.js?v=46124804624520036031743694419'

const urlParams = new URLSearchParams(window.location.search);
let step = parseInt(urlParams.get('step'));
if (isNaN(step)) {
  step = 1;
}

export function configureSteps(url, wall, skirting_board, params) {
  // Render the correct step on load
  const clickNext = document.getElementById('next');
  updateStepOrRedirect(step, clickNext, url, wall, skirting_board, params); 
  clickNext.addEventListener('click', function (event) {
    if (step < 6) {
      step++;
    }
    updateStepOrRedirect(step, clickNext, url, wall, skirting_board, params)
  });
  const clickPrevious = document.getElementById('previous');
  clickPrevious.addEventListener('click', function (event) {
    if (step > 1) {
      step--;
    }
    updateStepOrRedirect(step, clickNext, url, wall, skirting_board, params)
  });
}


function logCustomerData(step, params) {
  let apiRoot = "http://127.0.0.1:8000";
  if(window.location.hostname == "www.roomix.com") {
    apiRoot = "https://roomix.herokuapp.com"
  } else {
    return;
  }
  fetch(apiRoot + "/api/design_tool/interaction",
  {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    method: "POST",
    body: JSON.stringify({"step": step, "uuid": params.uuid, "session_count": params.session_count, "params": params}),
  }).then(function(res) {
    return res.json()
  }).then(function(data) {
     // console.log(data);
  })
}

// TODO: rework code so function needs less parameters, do we need to pass the URL in at all?
function updateStepOrRedirect(step, clickNext, url, wall, skirting_board, params) {
  let redirect = updateStep(step, clickNext);
  logCustomerData(step, params);

  if (redirect == true) {
    const wallHeightCm = Math.ceil((wall.geometry.parameters.height - skirting_board.geometry.parameters.height) * 100);
    const wallWidthCm = Math.ceil(params.wall_width * 100);
    const variantId = getVariantId(params, wallHeightCm);
    // No matter how big the design the variant for a large kit will always be returned
    // So we need to do additional checks here to see if we have an XL design
    const area = wallWidthCm * wallHeightCm;
    const largeKitMaxArea = 600 * 240;
    const extraLargeKitMaxArea = 800 * 240;
    let extraLargeDesign = false;
    if (area > extraLargeKitMaxArea) {
      openModal('extra-large-kit-modal');
      return;
    }
    if (area > largeKitMaxArea) {

      const radioCustomCut = document.querySelector('input[name="custom-cutting"]:checked')
      if(radioCustomCut.value === 'false') {
        openModal('custom-cutting-modal');
        document.querySelector('input[name="custom-cutting"]:not(:checked)').setAttribute('checked', 'checked');
        return;
      }

      /* Replacing checkbox with radio buttons
      const checkbox = document.getElementById("custom-cutting-checkbox");
      if(checkbox.checked == false) {
        openModal('custom-cutting-modal');
        checkbox.checked = true;
        return;
      }
       */
      extraLargeDesign = true;
    }
    location.href = getProductPageUrl(variantId, params, extraLargeDesign);
  }
}
function updateTitle(title) {
	const titleElement = document.getElementById('step-title');
	titleElement.innerHTML = title;
}
function updateStepNavHeader(step) {
	const stepNav = document.querySelector('.steps-nav-header');
  stepNav.querySelectorAll('li').forEach(function (element) {
		if (Number(element.dataset.step) < step) {
      element.classList.remove('active');
			element.classList.add('done');
		} else if (Number(element.dataset.step) === step) {
			element.classList.add('active');
      element.classList.remove('done');
		}
	});
}

function updateStep(step, clickNext) {
  if (step >= 5) {
    clickNext.innerHTML = "View kit";
  } else {
    clickNext.innerHTML = "Next";
  }
  // When is this ever hit?
  if (step === 6) {
    return true;
  }
  if (step === 1) {
    updateTitle('Step 1: Enter wall dimensions');
    document.getElementById('previous').disabled = true;
  } else if (step === 2) {
		updateTitle('Step 2: Create your panel design');
	} else if (step === 3) {
		updateTitle('Step 3: Select your paint colour');
	} else if (step === 4) {
		updateTitle('Step 4: Order wood strips');
	} else if (step === 5) {
		updateTitle('Step 5: Save your design');
	}
  updateStepNavHeader(step);
  // Don't update the URL if we're on the first step
  if (step > 1) {
    const url = new URL(window.location);
    url.searchParams.set('step', step);
    window.history.pushState(null, '', url.toString());
    document.getElementById('previous').disabled = false;
  }

  const elements = document.querySelectorAll('.controls-step');
  for (const element of elements) {
    let elementStep = parseInt(element.getAttribute('data-step'));
    if(step == elementStep){
      element.style.display = 'block';
    }else{
      element.style.display = 'none';
    }
  }
  return false;
}